document.addEventListener('DOMContentLoaded', function () {
  const buttonLeft = document.getElementById('column-button-left')
  const buttonRight = document.getElementById('column-button-right')
  const buttonsContainer = document.querySelector('.column-navigation')
  const currentRoute = window.location.pathname.replace(/\/$/, '').split('/').pop()
  const currentRouteDiv = document.getElementById(currentRoute)
  const parentColumn = currentRouteDiv?.closest('.column')
  const parendColumnIndex = parentColumn ? Array.from(parentColumn.parentNode.children).indexOf(parentColumn) : null

  let screenWidth = window.innerWidth
  let currentIndex = parendColumnIndex && screenWidth <= 1080 ? parendColumnIndex : 0 // Start with the first column visible on smaller screens
  let maxIndex = 0

  if (currentRouteDiv) {
    currentRouteDiv.classList.add('active')
    currentRouteDiv.scrollIntoView()
  }

  function getMaxIndex() {
    const columns = document.querySelectorAll('.column').length
    if (screenWidth <= 720) {
      // Mobile: only one column visible
      maxIndex = columns - 1
    } else if (screenWidth <= 1080) {
      // Tablet: two columns visible
      maxIndex = columns - 2
    } else {
      // Desktop: all columns visible, no scrolling needed
      maxIndex = 0
    }
  }

  function updateButtonVisibility() {
    buttonLeft.style.display = currentIndex > 0 ? '' : 'none' // Hide left button if first column is visible
    buttonRight.style.display = currentIndex < maxIndex ? '' : 'none' // Hide right button if no more columns to the right
  }

  function updateColumnVisibility() {
    const columns = document.querySelectorAll('.column')

    columns.forEach((column, index) => {
      column.style.display =
        index >= currentIndex && index < currentIndex + (screenWidth <= 720 ? 1 : screenWidth <= 1080 ? 2 : 3)
          ? ''
          : 'none'
    })

    // Adjust buttons container visibility based on screen width
    buttonsContainer.style.display = screenWidth <= 1080 ? 'flex' : 'none'

    updateButtonVisibility() // Update button visibility based on the current index and screen size
  }

  // Event listeners for buttons
  buttonLeft.addEventListener('click', function () {
    currentIndex = Math.max(currentIndex - 1, 0) // Ensure index doesn't go below 0
    updateColumnVisibility()
  })

  buttonRight.addEventListener('click', function () {
    currentIndex = Math.min(currentIndex + 1, maxIndex) // Ensure index doesn't exceed max
    updateColumnVisibility()
  })

  // Listen for resize event to adjust layout and button visibility
  window.addEventListener('resize', function () {
    getMaxIndex()
    currentIndex = Math.min(currentIndex, maxIndex) // Adjust currentIndex on resize, if necessary
    screenWidth = window.innerWidth
    updateColumnVisibility()
  })

  // Initial setup
  getMaxIndex()
  updateColumnVisibility()

  // read more button
  document.querySelectorAll('.read-more').forEach(function (item) {
    item.addEventListener('click', function () {
      this.closest('.column-content-post').classList.toggle('active')
    })
  })

  document.querySelectorAll('.column-content-post-title a').forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault()
      const post = this.closest('.column-content-post')
      post.classList.toggle('active')
      post.scrollIntoView()
    })
  })
})
